import { eTypeAsnProcess } from '../../../enums/eTypeAsnProcess'
import { Batch } from '../../../interfaces/Batch'
import { actionTypes } from '../types/actionTypes'
import {
  GenericErrorType,
  GenericInputType,
  ReducerPutAwayState
} from '../types/reducerTypes'

const initialInputValues: GenericInputType = {
  error: '',
  value: '',
  status: 'default'
}
const errorMessage: GenericErrorType = {
  error: '',
  status: 'default'
}

/*
Copyright 2022-04-07 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agregan reducer para sku y ubicación

Copyright 2022-04-08 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agregan reducer para listado de skus

Copyright 2022-04-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agrega reducer para exceso (calculo y estado)
*/

export const initialState: ReducerPutAwayState = {
  isSelected: 'AsnNumber',
  searchValue: '',
  positionId: 0,
  workOrderInboundLocate: [],
  error: errorMessage,
  step: 1,
  loading: false,
  item: undefined,
  ubication: initialInputValues,
  skuEan: initialInputValues,
  inputQty: initialInputValues,
  isSelectedFieldView: 'skuId',
  SkuListOnPosition: [],
  isShowNotification: false,
  isShowExcess: false,
  isExcess: false,
  isPreSale: false,
  calculatedExcess: 0,
  userId: 0,
  calculatedInbound: 0,
  skuLocated: '',
  isFlipped: { isFlipped: false, option: 1 },
  workOrderSkuHistory: [],
  loadingHistory: false,
  unknownFilter: 1,
  isUnknownScreen: false,
  skuUnknown: initialInputValues,
  suppliersUnknown: [],
  originsUnknown: [],
  titlteDocsMatch: '',
  lastSearchedBy: '',
  typePositionId: 0,
  showFefoModal: false,
  selectedBatchId: undefined,
  selectedBatchList: new Map<number, Batch>(),
  currentBatches: [],
  currentBatchesTimestamp: null,
  skuFefoType: {
    hasBatchNumber: false,
    hasExpirationDate: false,
    modalTitle: 'Lotes',
    modalType: 'batch'
  },
  showBatchCompletedModal: false,
  completedBatchInfo: null,
  notifiedCompletedBatches: new Set<number>(),
  headerParamSearchValue: eTypeAsnProcess.Inbound.toString() // asigna para que quede el primer seleccionable por defecto
}

// Creación del reducer el cual recibira como parametro nuestro estado y nuestras acciones
export const putAwayReducer = (
  state: ReducerPutAwayState,
  action: actionTypes
) => {
  switch (action.type) {
    case 'setSearch':
      return {
        ...state,
        isSelected: action.payload
      }
    case 'setSearchValue':
      return {
        ...state,
        searchValue: action.payload
      }
    case 'setWorkOrderLocate':
      return {
        ...state,
        workOrderInboundLocate: action.payload
      }
    case 'setItem':
      return {
        ...state,
        item: action.payload,
        notifiedCompletedBatches: new Set<number>()
      }
    case 'setError':
      return {
        ...state,
        error: action.payload
      }
    case 'setStep':
      return {
        ...state,
        step: action.payload
      }
    case 'setLoading':
      return {
        ...state,
        loading: action.payload
      }
    case 'setInputQty':
      return {
        ...state,
        inputQty: action.payload
      }
    case 'setUbication':
      return {
        ...state,
        ubication: action.payload
      }
    case 'setSkuEan':
      return {
        ...state,
        skuEan: action.payload
      }
    case 'setSkuUnknown':
      return {
        ...state,
        skuUnknown: action.payload
      }
    case 'setResetState':
      return initialState

    case 'setViewField':
      return {
        ...state,
        isSelectedFieldView: action.payload
      }
    case 'setItemList':
      return {
        ...state,
        SkuListOnPosition: action.payload
      }
    case 'setResetPageState':
      return {
        ...state,
        inputQty: initialInputValues,
        skuEan: initialInputValues,
        ubication: initialInputValues,
        SkuListOnPosition: [],
        selectedBatchId: undefined,
        currentBatches: [],
        currentBatchesTimestamp: null
      }

    case 'setIsShowNotification': {
      return {
        ...state,
        isShowNotification: action.payload
      }
    }
    case 'setPositionId':
      return {
        ...state,
        positionId: action.payload
      }
    case 'setTypePositionId':
      return {
        ...state,
        typePositionId: action.payload
      }
    case 'setResetLocate':
      return {
        ...state,
        inputQty: initialInputValues,
        skuEan: initialInputValues,
        selectedBatchId: undefined
      }
    case 'setIsExcess':
      return {
        ...state,
        isExcess: action.payload
      }
    case 'setIsPreSale':
      return {
        ...state,
        isPresale: action.payload
      }
    case 'setCalculatedExcess': {
      return {
        ...state,
        calculatedExcess: action.payload,
        isExcess: action.payload > 0
      }
    }

    case 'setUserId':
      return {
        ...state,
        userId: action.payload
      }

    case 'setIsShowExcess': {
      return {
        ...state,
        isShowExcess: action.payload
      }
    }
    case 'setCalculatedInbound':
      return {
        ...state,
        calculatedInbound: action.payload
      }

    case 'setSkuLocated':
      return {
        ...state,
        skuLocated: action.payload
      }
    case 'setIsFlipped':
      return {
        ...state,
        isFlipped: action.payload
      }

    case 'setWorkOrderSkuHistory':
      return {
        ...state,
        workOrderSkuHistory: action.payload
      }
    case 'setLoadingHistory':
      return {
        ...state,
        loadingHistory: action.payload
      }
    case 'setUnknownFilter':
      return {
        ...state,
        unknownFilter: action.payload
      }
    case 'setIsUnknownScreen':
      return {
        ...state,
        isUnknownScreen: action.payload
      }
    case 'setSuppliersUnknown':
      return {
        ...state,
        suppliersUnknown: action.payload
      }
    case 'setOriginsUnknown':
      return {
        ...state,
        originsUnknown: action.payload
      }
    case 'setTitlteDocsMatch':
      return {
        ...state,
        titlteDocsMatch: action.payload
      }
    case 'setLastSearchedBy':
      return {
        ...state,
        lastSearchedBy: action.payload
      }
    case 'setShowFefoModal':
      return {
        ...state,
        showFefoModal: action.payload
      }
    case 'setSelectedBatchId':
      return {
        ...state,
        selectedBatchId: action.payload
      }
    case 'setBachList': {
      const newMap = new Map(state.selectedBatchList)
      newMap.set(action.payload.batchId, action.payload)
      return {
        ...state,
        selectedBatchList: newMap
      }
    }
    case 'setCurrentBatches':
      return {
        ...state,
        currentBatches: action.payload
      }
    case 'setCurrentBatchesWithTimestamp':
      return {
        ...state,
        currentBatches: action.payload.batches,
        currentBatchesTimestamp: action.payload.timestamp
      }
    case 'invalidateBatchCache':
      return {
        ...state,
        currentBatchesTimestamp: null
      }
    case 'setSkuFefoType':
      return {
        ...state,
        skuFefoType: action.payload
      }
    case 'setShowBatchCompletedModal':
      return {
        ...state,
        showBatchCompletedModal: action.payload
      }
    case 'setCompletedBatchInfo':
      return {
        ...state,
        completedBatchInfo: action.payload
      }
    case 'addNotifiedCompletedBatch': {
      const newSet = new Set(state.notifiedCompletedBatches)
      newSet.add(action.payload)
      return {
        ...state,
        notifiedCompletedBatches: newSet
      }
    }
    case 'removeNotifiedCompletedBatch': {
      const newSet = new Set(state.notifiedCompletedBatches)
      newSet.delete(action.payload)
      return {
        ...state,
        notifiedCompletedBatches: newSet
      }
    }
    case 'resetNotifiedCompletedBatches':
      return {
        ...state,
        notifiedCompletedBatches: new Set<number>()
      }
    case 'setHeaderParamSearch':
      console.log(action.payload)
      return {
        ...state,
        headerParamSearchValue: action.payload
      }
    default:
      return state
  }
}
